<template>
  <dashboard-topbar/>
  <div class="register">
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-6">
        <div class="auth-block">
          <div class="form-label-block">
            <div class="title">
              <h1>{{ $t('Authorization') }}</h1>
              <div class="help-text">
                {{ $t('auth_title_help_text') }}
              </div>
            </div>
          </div>
          <div class="email-block social-block" :class="isShowEmailBlock ? 'active' : 'inactive'">
            <a class="login-bnt-google" :href="authGoogleUrl" v-if="authGoogleUrl">
              <svg width="18" height="17"
                   xmlns="http://www.w3.org/2000/svg"
                   xmlns:xlink="http://www.w3.org/1999/xlink"
                   viewBox="0 0 48 48">
                <defs><path id="a" d="M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24
                37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6
                4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z"/>
                </defs>
                <clipPath id="b"><use xlink:href="#a" overflow="visible"/>
                </clipPath>
                <path clip-path="url(#b)" fill="#FBBC05" d="M0 37V11l17 13z"/>
                <path clip-path="url(#b)" fill="#EA4335" d="M0 11l17 13 7-6.1L48 14V0H0z"/>
                <path clip-path="url(#b)" fill="#34A853" d="M0 37l30-23 7.9 1L48 0v48H0z"/>
                <path clip-path="url(#b)" fill="#4285F4" d="M48 48L17 24l-4-3 35-10z"/>
              </svg>
              {{ $t('Google') }}
            </a>
            <a class="login-bnt-google" :href="authFacebookUrl" v-if="authFacebookUrl">
              <svg width="35" height="35"
                  enable-background="new 0 0 512 512"
                   id="Layer_1" version="1.1"
                   viewBox="0 0 512 512"
                   xml:space="preserve"
                   xmlns="http://www.w3.org/2000/svg"
                   xmlns:xlink="http://www.w3.org/1999/xlink">
                <linearGradient gradientTransform="matrix(1 0 0 -1 -41.66 349.04)"
                                gradientUnits="userSpaceOnUse"
                                id="f_1_" x1="213.2162" x2="363.2099"
                                y1="198.8942" y2="48.9005">
                  <stop offset="0" style="stop-color:#3B5998"/><stop offset="1" style="stop-color:#336699"/>
                </linearGradient>
                <path d="M277.41,400.519V272.058h42.82l10.705-53.525H277.41v-21.41
                c0-21.41,10.726-32.115,32.115-32.115h21.41v-53.525c-10.705,0-23.98,0-42.82,0c-39.341,0-64.23,30.841-64.23,74.935v32.115h-42.82
                v53.525h42.82v128.46L277.41,400.519L277.41,400.519z" fill="url(#f_1_)" id="f_9_"/>
              </svg>
              {{ $t('Facebook') }}
            </a>
          </div>
          <div class="phone-block" :class="isShowPhoneBlock ? 'active' : 'inactive'">
            <form @submit.prevent="onSubmit" autocomplete="off" >
              <div :hidden="isCodeSend" class="mb-3">
                <div class="phone-label">
                  <label for="phone" class="form-label">{{ $t('PhoneNumber') }}</label>
                  <div class="form-check form-check-right">
                    <input class="form-check-input" type="checkbox" id="isPhoneOtherCountry"
                           v-model="isPhoneOtherCountry">
                    <label class="form-check-label" for="isPhoneOtherCountry">
                      {{ $t('AnotherCountry') }}
                    </label>
                  </div>
                </div>
                <div class="form-input">
                  <input type="text"
                         name="phone"
                         class="form-control input-dirty" :class="!isPhoneOtherCountry ? 'show' : 'hide'"
                         placeholder="+38 (___) ___-__-__"
                         id="phone"
                         v-model="phone"
                         aria-describedby="phone"
                         :disabled="isSubmitting"
                  >
                  <input type="text"
                         name="raw_phone"
                         class="form-control input-dirty" :class="isPhoneOtherCountry ? 'show' : 'hide'"
                         placeholder="+____________"
                         id="raw_phone"
                         v-model="raw_phone"
                         aria-describedby="raw_phone"
                         :disabled="isSubmitting"
                  >
                  <div class="form-text" :class="isPhoneInvalid ? 'danger' : 'normal'">{{ phoneMsg }}</div>
                </div>
              </div>
              <div :hidden="!isCodeSend" class="form-input mb-3">
                <label for="code" class="form-label">{{ $t('Code') }}</label>
                <input type="text"
                       name="code"
                       class="form-control input-dirty"
                       placeholder="______"
                       id="code"
                       v-model="code"
                       aria-describedby="code"
                       :disabled="isSubmitting"
                >
                <div class="form-text" :class="isCodeInvalid ? 'danger' : 'normal'">{{ codeMsg }}</div>
              </div>
              <div class="mt-4">
                <button class="btn btn-success" :disabled="isSubmitting">{{ $t('Continue') }}</button>
              </div>
            </form>
            <span class="hr-offset">{{ $t('or') }}</span>
            <div class="login-bnt" @click="showEmailBlock">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="evenodd"
                   class="bi bi-box-arrow-in-right" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0
                1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5
                2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0z"/>
                <path fill-rule="evenodd" d="M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293
                7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"/>
              </svg>
              {{ $t('Email') }}
            </div>
          </div>
          <div class="email-block" :class="isShowEmailBlock ? 'active' : 'inactive'">
            <div class="login-bnt" @click="showPhoneBlock">
              <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.61711 14.336L12.2478 11.7053L16.5953 14.7374L15.6201 15.7127C14.9705 16.3622 14.017 16.6032
                13.1367 16.3403C10.4457 15.5364 8.02832 14.0625 5.88456 11.9188C3.74081 9.77504 2.26698 7.35765
                1.46307 4.66663C1.2001 3.7864 1.44109 2.83285 2.09069 2.18325L3.06594 1.20801L6.0981
                5.55552L3.46738 8.18624" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              {{ $t('Phone') }}
            </div>
            <span class="hr-offset">{{ $t('or') }}</span>
            <form class="email-login" @submit.prevent="onSubmitEmail">
              <div class="form-group required">
                <label class="control-label" for="loginform-email">{{ $t('Email') }}</label>
                <input type="email" id="email" name="email" v-model="email">
                <p class="emailMsg danger">{{ emailMsg }}</p>
              </div>
              <div class="form-group required">
                <label class="control-label" for="password">{{ $t('Password') }}</label>
                <input type="password" id="password" class="password" name="password" v-model="password">
                <p class="passwordMsg danger">{{ passwordMsg }}</p>
              </div>
              <button type="submit" class="btn btn--accent btn--full">{{ $t('Signin') }}</button>
            </form>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-6">
        <div class="login-block">
          <h3>{{ $t('signupPage.rightBlock.title') }}</h3>
          <ul>
<!--            <li>-->
<!--              {{ $t('signupPage.rightBlock.item_1') }}-->
<!--              <span class="info-asterisk">*</span>-->
<!--            </li>-->
            <li>
              {{ $t('signupPage.rightBlock.item_2') }}
            </li>
            <li>
              {{ $t('signupPage.rightBlock.item_3') }}
            </li>
            <li>
              {{ $t('signupPage.rightBlock.item_4') }}
            </li>
            <li>
              {{ $t('signupPage.rightBlock.item_5') }}
            </li>
            <li>
              {{ $t('signupPage.rightBlock.item_6') }}
            </li>
          </ul>
<!--          <div class="section-desc info-asterisk-container">-->
<!--            <div class="info-asterisk">*</div>-->
<!--            <div class="info-asterisk__info">-->
<!--              <p>-->
<!--                {{ $t('signupPage.rightBlock.item_7') }}-->
<!--              </p>-->
<!--            </div>-->
<!--          </div>-->
          <hr>
          <strong></strong>
          <router-link class="btn btn--not-accent mt-10" :to="{name: 'signup'}">
            {{ $t('Signup') }}
          </router-link>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import Inputmask from "inputmask"
  import {actionTypes, mutationTypes} from "@/store/modules/auth";
  import {mapState} from "vuex";
  import DashboardTopbar from "@/components/Topbar.vue";

  export default {
    name: 'DashboardSignup',
    components: {
      DashboardTopbar
    },
    data() {
      return {
        csrf: '',
        authGoogleUrlNew: '',
        authFacebookUrlNew: '',
        phone: '',
        raw_phone: '',
        isPhoneOtherCountry: false,
        code: '',
        email: '',
        password: '',
        emailMsg: '',
        passwordMsg: '',
        isShowPhoneBlock: false,
        isShowEmailBlock: true
      }
    },
    mounted() {
      this.$nextTick(function () {
        let phoneSelector = document.getElementById("phone");
        if (JSON.stringify(phoneSelector) !== "null"){
          let maskPhone = new Inputmask({ mask: "+38 (999) 999-99-99", greedy: false})
          maskPhone.mask(phoneSelector)
        }
        let codeSelector = document.getElementById("code");
        if (JSON.stringify(codeSelector) !== "null"){
          let maskCode = new Inputmask({ mask: "999999", greedy: false})
          maskCode.mask(codeSelector)
        }
      })
      this.csrf = document.getElementById('app').dataset.csrf;
      this.$store.dispatch(actionTypes.setCsrf, this.csrf);

      this.authGoogleUrlNew = document.getElementById('app').dataset.authGoogleUrl;
      this.$store.commit(mutationTypes.setAuthGoogleUrl, this.authGoogleUrlNew)

      this.authFacebookUrlNew = document.getElementById('app').dataset.authFacebookUrl;
      this.$store.commit(mutationTypes.setAuthFacebookUrl, this.authFacebookUrlNew)

      this.$store.commit(mutationTypes.setPhoneMsg, this.$t("EnterYourPhoneNumber"));
      this.$store.commit(mutationTypes.setCodeMsg, this.$t("EnterCodeFromSms"));
    },
    methods: {
      onSubmit() {
        if (this.codeClean === ''){
          // Ony for phone enter
          if (!this.isPhoneOtherCountry && this.phoneClean.length < 12) {
            this.$store.commit(mutationTypes.setIsPhoneInvalid, true);
          } else {
            // Send snm for phone
            this.$store.dispatch(actionTypes.sendCode, {phone: this.phoneClean, csrf: this.csrf})
          }
        } else if (this.codeClean.length < 6){
          this.$store.commit(mutationTypes.setIsCodeInvalid, true);
        } else {
          // Auth by phone sms code
          this.$store
              .dispatch(actionTypes.authByCode, {phone: this.phoneClean, code: this.codeClean, csrf: this.csrf})
              .then(data => {
                console.log("Auth Success")
                if (data['token'] !== undefined && data['token'] !== ''){
                  let query = {};
                  if (this.$route.query.next){
                    query = {next: this.$route.query.next}
                  }
                  this.$router.push({name: 'dashboard', query: query})
                }
          })
        }
      },
      onSubmitEmail() {
        this.emailMsg = ''
        this.passwordMsg = ''
        // Auth by email
        this.$store
            .dispatch(actionTypes.authByEmail, {email: this.email, password: this.password})
            .then(response => {
              if (response.status === 200){
                if (response.data['token'] !== undefined && response.data['token'] !== '') {
                  console.log("Auth Success")
                  this.$router.push({name: 'dashboard'})
                }
              } else {
                  if (
                      response.data['errors']['non_field_errors'] !== undefined &&
                      response.data['errors']['non_field_errors'][0]['code'] === "authorization"){
                    this.passwordMsg = response.data['errors']['non_field_errors'][0]['message']
                  }
                  if (response.data['errors']['email'] !== undefined){
                    this.emailMsg = response.data['errors']['email'][0]['message']
                  }
                  if (response.data['errors']['password'] !== undefined){
                    this.passwordMsg = response.data['errors']['password'][0]['message']
                  }
                }
              })
      },
      showPhoneBlock(){
        this.isShowEmailBlock = false
        this.isShowPhoneBlock = true
      },
      showEmailBlock(){
        this.isShowEmailBlock = true
        this.isShowPhoneBlock = false
      }
    },
    computed: {
      ...mapState({
        isSubmitting: state => state.auth.isSubmitting,
        phoneMsg: state => state.auth.phoneMsg,
        isPhoneInvalid: state => state.auth.isPhoneInvalid,
        isCodeInvalid: state => state.auth.isCodeInvalid,
        isCodeSend: state => state.auth.isCodeSend,
        authGoogleUrl: state => state.auth.authGoogleUrl,
        authFacebookUrl: state => state.auth.authFacebookUrl,
      }),
      codeMsg() {
        let msg = this.$store.state.auth.codeMsg
        if (msg && this.isCodeInvalid === false && this.isCodeSend === true && this.phone){
          return `${msg} ${this.phone}`
        }
        return msg
      },
      phoneClean(){
        let phone = ''
        let phone_str = this.phone
        if (this.isPhoneOtherCountry){
          phone_str = this.raw_phone
        }
        let phoneItems = phone_str.match(/[0-9]+/g)
        if (phoneItems === null) {
          return ''
        }
        phoneItems.forEach(function(i) {
          phone += i;
        })
        return phone
      },
      codeClean(){
        let code = ''
        let codeItems = this.code.match(/[0-9]+/g)
        if (codeItems === null) {
          return ''
        }
        codeItems.forEach(function(i) {
          code += i;
        })
        return code
      }
    },
  }
</script>

<style scoped lang="scss">
  @import "@/scss/variables.scss";
  @import "@/scss/mixins.scss";

  .hide{
    display: none !important;
  }
  .show{
    display: block !important;
  }

  .register {
    overflow-x: hidden;
    .title {
      padding-top: 30vh;
      margin-bottom: 10px;
      @media only screen and (max-width: $max-width-tablet) {
        padding-top: 90px;
      }
      .help-text{
        font-size: 14px;
        color: $fi;
        max-width: 380px;
      }
    }
    .description{
      margin-bottom: 40px;
    }
    .form-label-block{
      display: flex;
      flex-direction: column
    }
    .form-phone-block{
      display: flex;
    }
    .auth-block{
      margin-bottom: 20px;
      @media only screen and (min-width: $max-width-laptop-large) {
        margin-left: 28vw;
      }
      @media only screen and (max-width: $max-width-laptop-large) and (min-width: $max-width-laptop) {
        margin-left: 18vw;
      }
      @media only screen and (max-width: $max-width-laptop) and (min-width: $max-width-tablet) {
        margin-left: 9vw;
      }
      @media only screen and (max-width: $max-width-tablet) and (min-width: $max-width-tablet-small) {
        margin-left: 30vw;
      }
      @media only screen and (max-width: $max-width-tablet-small) and (min-width: $max-width-mobile){
        margin-left: 9vw;
      }
      @media only screen and (max-width: $max-width-mobile){
        margin-left: 5px;
        margin-right: 5px;
      }
    }
    .login-block{
      display: flex;
      flex-direction: column;
      padding-top: 30vh;
      padding-bottom: 50px;
      padding-left: 100px;
      padding-right: 225px;
      height: 100vh;
      background-color: $bd-y-gray;
      @media only screen and (max-width: $max-width-laptop) {
        padding-left: 50px;
        padding-right: 100px;
        height: 100vh;
      }
      @media only screen and (max-width: $max-width-tablet) {
        padding-top: 30px;
      }
      @media only screen and (max-width: $max-width-mobile) {
        padding-top: 30px;
        padding-left: 10px;
        padding-right: 10px;
        height: auto;
      }
      .info-asterisk-container{
        display: flex;
        font-size: 14px;
      }
      .btn{
        max-width: 280px;
      }
      ul {
          display: block;
          list-style-type: disc;
          margin-block-start: 1em;
          margin-block-end: 1em;
          margin-inline-start: 0px;
          margin-inline-end: 0px;
          padding-inline-start: 40px;
      }
      ul li {
        font-size: 14px;
        line-height: 18px;
        padding-bottom: 10px;
      }
      ul li:before {
          background: $danger;
          content: "";
          display: block;
          height: 8px;
          left: 0;
          position: absolute;
          top: 4px;
          width: 2px;
      }
    }
    #phone, #password {
      max-width: 200px;
    }

    .danger {
      color: $danger;
    }

    .normal {
      color: $fd;
    }
    .email-block{
      display: flex;
      flex-direction: column;
      width: 380px;
      @media only screen and (max-width: $max-width-mobile) {
        width: unset;
      }
      .login-bnt{
        margin: 0 0 16px;
        background: $bd-y-gray-dark;
        border: 0;
        border-radius: 3px;
        cursor: pointer;
        height: 50px;
        line-height: 50px;
        padding: 0;
        text-align: center;
      }
      .login-bnt:hover{
        color: $fi;
        svg{
          opacity: .5;
        }
      }
      .login-bnt-google{
        color: $fd;
        margin: 0 0 16px;
        background: white;
        border: 1px solid $bd-y-gray-dark;
        border-radius: 3px;
        cursor: pointer;
        height: 50px;
        line-height: 50px;
        padding: 0;
        text-align: center;
        text-decoration: none;
      }
      .login-bnt-google:hover{
        color: $fi;
        background: $bd-y-gray-dark;
        svg{
          opacity: .5;
        }
      }
      .btn{
        -webkit-box-align: start;
        -ms-flex-align: start;
        align-items: flex-start;
        border: 0;
        border-radius: 3px;
        cursor: pointer;
        display: inline-block;
        font-family: DIN\ 2014,sans-serif;
        height: 50px;
        line-height: 50px;
        padding: 0;
        text-align: center;
        transition: color .3s ease;
        width: 100%;
        -webkit-appearance: none;
        background: $btn-cart;
        color: $bg-100;
      }
    }
    .social-block{
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      gap: 10px;
      .login-bnt-google {
        flex-basis: calc(50% - 5px)
      }
    }
    .phone-block{
      margin-top: 30px;
      display: flex;
      flex-direction: column;
      width: 380px;
      form{
        padding-bottom: 20px;
      }
      .login-bnt{
        margin: 0 0 16px;
        background: $bd-y-gray-dark;
        border: 0;
        border-radius: 3px;
        cursor: pointer;
        height: 50px;
        line-height: 50px;
        padding: 0;
        text-align: center;
      }
      .btn{
        -webkit-box-align: start;
        -ms-flex-align: start;
        align-items: flex-start;
        border: 0;
        border-radius: 3px;
        cursor: pointer;
        display: inline-block;
        font-family: DIN\ 2014,sans-serif;
        height: 50px;
        line-height: 50px;
        padding: 0;
        text-align: center;
        transition: color .3s ease;
        width: 100%;
        -webkit-appearance: none;
        background: $btn-cart;
        color: $bg-100;
      }
      .form-input {
        input {
          line-height: 1;
          padding: 0 40px 0 16px;
          outline: none;
          display: block;
          width: 100%;
          appearance: none;
          background: #fbf8f8;
          border: 1px solid transparent;
          border-radius: 3px;
          font-family: DIN\ 2014, sans-serif;
          height: 40px;
          transition: border .3s ease;
          max-width: unset !important;
        }
      }
      .form-check-right{
      display: flex;
      justify-content: right;
      label{
        padding-left: 8px;
      }
    }
    .phone-label{
      display: flex;
      justify-content: space-between;
    }
  }
  .inactive{
    display: none !important;
  }
  .active{
    display: flex;
  }
  .hr-offset{
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    font-weight: 600;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    line-height: 18px;
    margin: 0 0 16px;
  }
  .hr-offset:after, .hr-offset:before {
    margin: 0 10px;
    background: $bd-y-gray-dark;;
    content: "";
    display: block;
    height: 1px;
    width: calc(100% - 12px);
  }
  .form-group {
    margin: 0 0 24px;
    position: relative;

    .control-label {
      color: $fi;
      display: block;
      font-size: 12px;
      line-height: 9px;
      margin: 0 0 8px;
    }

    input {
      line-height: 1;
      padding: 0 40px 0 16px;
      outline: none;
      display: block;
      width: 100%;
      appearance: none;
      background: #fbf8f8;
      border: 1px solid transparent;
      border-radius: 3px;
      font-family: DIN\ 2014, sans-serif;
      height: 40px;
      transition: border .3s ease;
      max-width: unset !important;
    }
  }
  }
</style>
